"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shipmentTrackingAttributes = exports.shipmentTrackingSelector = exports.shipmentTrackingType = exports.shipmentTrackingRef = void 0;
exports.shipmentTrackingRef = 'shipment-tracking';
exports.shipmentTrackingType = 'shipment-tracking';
exports.shipmentTrackingSelector = "id='shipment-tracking-block'";
exports.shipmentTrackingAttributes = `${exports.shipmentTrackingSelector} data-gjs-type="shipment-tracking" data-gjs-highlightable="false" data-gjs-copyable="false" data-gjs-droppable="false"`;
